'use strict';

exports.__esModule = true;
// Define what props.theme will look like
exports.default = {
  primary: '#e95160',
  secondary: '#183a64',
  secondaryLight: '#35557b',
  white: '#ffffff',
  grayA0: '#A0A0A0',
  grayF3: '#F3F3F1',
  grayF7: '#F7F7F7',
  grayE6: '#E6E6E6',
  textColor: '#505050',
  textColor69: '#696969',
  textColor3: '#333333',
  textColorD8: '#d8d8d8',
  textColor9D: '#9d9d9c',
  green: '#7ac943',
  // --- Rollen-Farbpalette (Token-Gate-Tilgung 2026-06): die Questionnaire-Rollenfarben
  // als Tokens konsolidiert (vorher roh dupliziert in QuestionnaireRoles + AnswerCheckbox).
  // student=primary, teacher=secondary; company + educationCompanion bekommen hier ihre
  // Single-Source. Werte unverändert -> render-neutral.
  companyColor: '#f3a6ac',
  educationCompanionColor: '#5da3d9',
  // --- fontWeight: NICHT-Standard-Mapping (historisch an die @font-face-Files gebunden).
  // fontWeightBold=400 registriert die DATEI Montserrat-Bold (= echtes Bold!); rohes
  // `font-weight: bold`/700 trifft dagegen fontWeightHeavyBold=700 (Montserrat-ExtraBold)
  // → eine Stufe ZU fett. fontWeightUpperBold=600 hat KEIN @font-face (Browser faux-boldet).
  // Daher: nie rohes font-weight, immer diese Tokens (Gate: scripts/check-token-bypass.sh).
  // Echtes Rename auf CSS-Semantik = eigener Bigger Bet (Risiko @font-face-Sync), NICHT hier.
  fontWeightLight: 100,
  fontWeightRegular: 200,
  fontWeightMedium: 300,
  fontWeightBold: 400,
  fontWeightSemiBold: 500,
  fontWeightUpperBold: 600,
  fontWeightHeavyBold: 700,
  borderRadiusDefault: '3px',
  borderRadiusRound: '50%',
  borderColor: '#e6e6e6',
  // --- Redesign 2026-06 (Design Quick Wins): errorColor von der Marken-Koralle
  // (#e95160 == primary) entkoppelt — Fehler bekommen ein eigenes, klar unter-
  // scheidbares Rot, das nie mit der Marke verwechselt wird. Single-Source: liegt
  // jetzt hier in shared (vorher nur via education/theme.js-Override). #d92b3c ~4,6:1
  // auf Weiß (WCAG AA bestanden) vs. Koralle ~3,2:1.
  errorColor: '#d92b3c',
  warningColor: '#ffa834',
  // --- Redesign 2026-06 (Primitiv-Bibliothek, StatusPill): Erfolg-/Status-Tokens als
  // Single-Source im shared-Theme, damit die UI-Primitive (shared/components/ui/*) self-
  // contained sind (analog errorColor). successColor == #2e9e5b spiegelt das gedaempfte
  // approveColor (heute nur in education/theme.js) — der StatusPill-„done"-Ton braucht den
  // Wert auch OHNE den education-ThemeProvider. successTint/errorTint = die low-alpha
  // Fuell-Toene der Pills (gruen/rot ~10-12% Alpha) als Tokens statt roher rgba im styled.
  successColor: '#2e9e5b',
  successTint: 'rgba(46, 158, 91, 0.12)',
  errorTint: 'rgba(217, 43, 60, 0.10)',
  // navyTint = navy-getoente Flaeche (#eef2f7): Filter-Chips, Tabellen-Header, navy-Akzent-
  // Hintergruende des ManageStudents-Restyles. Bisher roh dupliziert -> hier Single-Source.
  navyTint: '#eef2f7',

  // --- Redesign 2026-06 (Design Quick Wins): Motion-Tokens. Zentrale Dauer-/Easing-
  // Werte, damit Timing app-weit in EINER Datei steuerbar ist (Voraussetzung für den
  // einheitlichen Hover-Lift der kommenden Primitiv-Wellen). Werte = die heute
  // dominanten Dauern; Konsum mit Fallback (theme.X || '…') = render-neutral.
  durationFast: '0.15s',
  durationBase: '0.25s',
  durationSlow: '0.3s',
  easingStandard: 'cubic-bezier(0.4, 0, 0.2, 1)',

  // --- Redesign 2026-06 (Primitiv-Bibliothek): Radius-/Elevation-Skala. Lebt im
  // shared-Theme, damit die UI-Primitive (shared/components/ui/*) self-contained
  // sind — auch außerhalb des education-ThemeProviders. education/theme.js kann
  // einzelne Werte weiterhin überschreiben (merge in pages/ThemeProvider.jsx).
  radiusSm: '6px',
  radiusMd: '10px',
  radiusLg: '16px',
  radiusPill: '999px',
  elevationSm: '0 1px 3px rgba(16, 24, 40, 0.08)',
  elevationMd: '0 4px 12px rgba(16, 24, 40, 0.10)',
  elevationLg: '0 12px 28px rgba(16, 24, 40, 0.12)',

  // --- Login-Award-Redesign 2026-07 (Etappe D): die EINE Login-Flaeche.
  // Foto-Ausbruch-Mechanik: Foto-Bereich (links) UND Form-Bereich (rechts)
  // teilen GENAU loginSurface; das finale Slide-Foto MUSS diesen Hintergrund
  // haben, dann verschmilzt seine rechte Kante unsichtbar in die Form-Flaeche.
  // Nur diesen EINEN Wert aendern, um die Flaechenfarbe zu retunen. Die Helfer-
  // Toene sind exakt auf loginSurface abgestimmt (aus dem hellen Blau der Navy-
  // Familie). Additiv (kein Override) — leben in shared, damit LoginVisual/
  // LoginSlider self-contained sind.
  loginSurface: '#E9F0F9', // Login-Flaeche (leichtes Blau, IBA-Navy-Familie)
  loginSurfaceLine: '#d2deee', // ruhige Border-/Hairline auf der Flaeche
  loginSurfaceFill: '#fcfdff', // helles Feld-Fill (hebt sich von der Flaeche ab)
  loginSurfaceText: '#2b3f59' // Lese-Text auf der Flaeche (Kontrast >= 4.5:1)

  // --- Spacing-Skala (Welle 2b 2026-06, Option B): WERT-basiert + an den echten App-
  // Rhythmus angepasst. Die App läuft real auf 5/10/15/20/25/30 (dominant 10px ×130),
  // NICHT auf einem 4/8-Grid. Der Helper `shared/styles/spacing.js` gibt space(10) ->
  // '10px' zurück (render-neutral; der Zahlenwert IST der px-Wert), sodass ALLE Bestands-
  // abstände render-neutral tokenisierbar sind. Die alten Index-Tokens space1..space9
  // (4/8-Grid) sind damit abgelöst (hatten 0 Konsumenten). `space` hier ist ein OPTIO-
  // NALER Override-Hook (Default undefiniert -> Helper liefert `${v}px`); zum zentralen
  // Re-Tunen einzelner Stufen könnte man space: { 10: '8px', ... } setzen.
};
module.exports = exports['default'];